import { useContext } from "react";

import type { BreakpointsActiveMap } from "@shared/context/BreakpointsContext";
import { BreakpointsContext } from "@shared/context/BreakpointsContext";

export const useBreakpoints = () => useContext<BreakpointsActiveMap>(BreakpointsContext);
